import React from 'react';
import styles from '../NDAGenerator.module.scss';

interface HeaderProps {
  currentMode: 'create' | 'review';
  setCurrentMode: (m: 'create' | 'review') => void;
  setShowPreview: (v: boolean) => void;
}

export const Header: React.FC<HeaderProps> = ({
  currentMode,
  setCurrentMode,
  setShowPreview
}) => {
  return (
    <div className={styles.introSection}>
      <h1 className={styles.introTitle}>
        NDA Generator <span className={styles.toolLabel}>Tool</span>
      </h1>
      <p className={styles.introDescription}>
        {currentMode === 'create'
          ? "Create professional NDAs using Zurich's official templates. Fill out the form and generate a Word document."
          : "Upload a customer NDA to analyze compliance with Zurich's requirements and get a detailed comparison."}
      </p>
      <div className={styles.ndaDisclaimerWrapper}>
        <div className={styles.aiDisclaimer} role="note" aria-live="polite">
          <div className={styles.aiDisclaimerIcon}>i</div>
          <div className={styles.aiDisclaimerContent}>
            <p>
              This tool may generate incorrect responses and may include
              information protected under intellectual property or privacy
              regulations.
            </p>
            <p>
              Therefore, the responses need to be carefully assessed and users
              should make their own judgment before using the responses.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.modeSelector}>
        <button
          className={`${styles.modeButton} ${
            currentMode === 'create' ? styles.active : ''
          }`}
          onClick={() => {
            setCurrentMode('create');
            setShowPreview(false);
          }}
        >
          Create NDA
        </button>
        <button
          className={`${styles.modeButton} ${
            currentMode === 'review' ? styles.active : ''
          }`}
          onClick={() => setCurrentMode('review')}
          style={
            currentMode === 'review'
              ? {
                  backgroundColor: 'var(--brand-primary, #1e88e5)',
                  color: 'var(--on-brand-primary, #ffffff)'
                }
              : undefined
          }
        >
          Review NDA Compliance
        </button>
      </div>
    </div>
  );
};
